export const Region = {
  Local: "LOCAL",
  International: "INTERNATIONAL",
};

export const Locale = {
  Vi: "vi",
  En: "en",
};